import React from "react"
import Style from "./NutritionCalculatorSelectedFoodStyle.module.styl"

const NutritionCalculatorSelectedFood = ({ selectedFood, handleClear }) => {
  return (
    <div className={Style.wrapper}>
      <p className={Style.brand_owner}>
        {selectedFood.data.brandOwner && selectedFood.data.brandOwner}
      </p>
      <p className={Style.food_name}>{selectedFood.data.description}</p>
      {selectedFood.data.labelNutrients && (
        <div className={Style.label_nutrients_holder}>
          <p>
            {selectedFood.data.labelNutrients.calories.value.toFixed(2)}
            <span>Cal</span>
          </p>
          <p>
            {selectedFood.data.labelNutrients.carbohydrates.value.toFixed(2)}
            <span>Carbs</span>
          </p>
          <p>
            {selectedFood.data.labelNutrients.fat
              ? selectedFood.data.labelNutrients.fat.value.toFixed(2)
              : "0"}
            <span>Fat</span>
          </p>
          <p>
            {selectedFood.data.labelNutrients.protein.value.toFixed(2)}
            <span>Protein</span>
          </p>
        </div>
      )}
      <button className={Style.clear_result} onClick={handleClear}>
        Изчисти резултата
      </button>
    </div>
  )
}

export default NutritionCalculatorSelectedFood
